export default {
  inventory: {
    labels: {
      chooseRoom: 'Sélectionnez une pièce :',
      addFurniture: 'Ajoutez des meubles aux pièces concernées :',
    },
  },
  furnitures: {
    title: 'liste des pièces',
    addCustomFurniture: 'Ajouter un meuble personnalisé',
    roomPlaceholder: 'Changer le nom de la pièce',
    quantity: 'Quantité',
    volume: 'Volume',
    rooms: {
      kitchen: 'Cuisine',
      livingRoom: 'Salon',
      bedRoom: 'Chambre',
      bathroom: 'Salle de bain',
    },
    addRoom: 'Ajouter une pièce',
    addFurniture: 'Ajouter des meubles',
    addBox: 'Ajouter des cartons',
    notification: {
      success: {
        title: 'Inventaire sauvegardé',
        text: 'Votre inventaire a bien été sauvegardé.',
      },
    },
    empty: 'Pas de fournitures',
    search: 'Recherche',
    selected: 'Meubles sélectionnées',
    custom: {
      title: 'Ajouter un meuble manuellement',
      dialogButton: 'Ajouter un meuble personnalisé',
      name: {
        label: 'Nom',
        warning: 'Un nom est nécessaire',
      },
      quantity: {
        label: 'Quantité',
        warning: 'Une quantité est nécessaire',
      },
      width: {
        label: 'Profondeur (cm)',
        warning: 'Une largeur est nécessaire',
      },
      height: {
        label: 'hauteur (cm)',
        warning: 'Une hauteur est nécessaire',
      },
      length: {
        label: 'Longueur (cm)',
        warning: 'Une longueur est nécessaire',
      },
      observations: {
        label: 'Observations concernant le meuble',
        placeholder: 'observations',
      },
    },
    disassemblyQuestion: 'Souhaitez-vous que ce meuble soit démonté et remonté par les déménageurs ?',
    disassembleAllFurniture: 'Je souhaite que tous les meubles soient\n'
      + 'démontés et remontés par défaut',
    furniture: 'meubles',
    disassembleAllFurnitureMobile: 'Démonter tous les meubles',
    disassembly: 'Démonter / Remonter',
    heavy: 'Poids > 100kg',
    success: {
      title: 'Inventaire sauvegardé',
      text: 'Votre inventaire a bien été sauvegardé',
    },
  },
  customFurniture: {
    errors: {
      width: 'La largeur du meubles doit être supérieur à 0',
      length: 'La longueur du meubles doit être supérieur à 0',
      height: 'La hauteur du meuble doit être supérieur à 0',
      name: 'Le nom du meuble est obligatoire',
    },
    labels: {
      name: 'Quel est le nom du meuble ?',
      length: 'Longueur en cm :',
      width: 'Profondeur en cm :',
      height: 'Hauteur en cm :',
      title: 'Ajouter un meuble personnalisé',
      placeholder: 'Nom du meuble',
    },
    create: 'Ajouter',
  },
  displayCustomerFurniture: 'Afficher vos meubles',
  search: 'Rechercher',
  yourFurniture: 'Vos meubles',
  warningDeletion: 'Êtes-vous sûr de vouloir supprimer la pièce et tous les meubles qu\'elle contient ({number} meubles) ?',
  deletionOnNextPage: 'La pièce que vous souhaitez supprimer contient des meubles. Vous pourrez la supprimer sur la prochaine page.',
  roomContent: 'La pièce que vous souhaitez supprimer contient les meubles suivant :',
  addPicture: 'Ajouter une photo',
  warningEmptyRooms: 'Certaines pièces sont vides et ne contiennent aucun meuble. Êtes-vous sûr de vouloir continuer ?',
};
